import { TApplicationState } from 'shared/types/redux';

export const selectIsAuthorized = (state: TApplicationState) => state.user.isAuthorized;
